module.exports = __webpack_public_path__ + "static/media/baylee.88a9b506.jpeg";